(function () {
  'use strict';

  class ProductLabelsComponent extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ['product'];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      this.render();
    }

    connectedCallback() {
      if (this._product) {
        this.render();
      }
    }

    render() {
      const labels = [];

      if (this._product && this._product.tags) {
        
        // 1. Logic for 'luxclusif' / 'PRELOVEDSTORK' tags
        if (this._product.tags.includes('luxclusif') || this._product.tags.includes('PRELOVEDSTORK')) {
          labels.push(`<div class="product-label-wrapper flex">
            <span class="product-label">
              <strong>Pre-Loved</strong>
            </span>
          </div>`);
        }

        // 2. Dynamic Product Label from persistent_note tag
        const noteTag = this._product.tags.find(tag =>
          tag.startsWith('persistent_note:') || tag.startsWith('pesistent_note:')
        );

        if (noteTag) {
          const labelText = noteTag.split(':').slice(1).join(':').trim();

          if (labelText) {
            labels.push(`<div class="product-label-wrapper flex">
              <span class="product-label">
                ${labelText}
              </span>
            </div>`);
          }
        }
      }

      this.innerHTML = labels.join('');
    }
  }

  customElements.define('rcc-product-labels', ProductLabelsComponent);
})();